import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Txt from "./typography/Txt";

const LoadingContent = ({
  linear = false,
  height = 28,
  sx,
  py = 4,
  children,
}) => (
  <Box
    sx={{
      display: "flex",
      // width: "100%",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
      background: "#ffffff",
      gap: 2,
      // height: height,
      py,
      ...sx,
    }}
  >
    {linear ? (
      <LinearProgress style={{ width: "100%" }} />
    ) : (
      <CircularProgress size={height} />
    )}

    {children && <Txt secondary>{children}</Txt>}
  </Box>
);

export default LoadingContent;
